import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React, { forwardRef } from 'react';
import styled, { css } from '@xstyled/styled-components';
import { getVariantColor } from '@trybeapp/ui.utilities';
import { HtmlDiv } from '@trybeapp/ui.elements';
import { system } from '@trybeapp/ui.system';

var _excluded = ["checkableField", "children", "disabled", "disabledIcon", "errorWarningIcon", "variant"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledLabel = /*#__PURE__*/styled.label(function (_ref) {
  var required = _ref.required,
    theme = _ref.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-shrink: 0;\n    align-items: flex-start;\n    line-height: body1;\n    ", ";\n    user-select: none;\n    ", "\n    > * {\n      &:not(:last-child) {\n        margin-right: sm;\n      }\n      :last-child {\n        ", ";\n      }\n    }\n  "])), theme.fields.label, system, required && requiredStyles);
});
var requiredStyles = /*#__PURE__*/css(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  &::after {\n    content: '*';\n    color: primary.500;\n    margin-left: xs;\n  }\n"])));
var Disabled = /*#__PURE__*/styled(HtmlDiv)(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  margin-right: xs;\n"])));
var Icon = /*#__PURE__*/styled(HtmlDiv)(function (_ref2) {
  var variant = _ref2.variant;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    margin-right: xs;\n    color: ", ";\n    fill: ", ";\n    flex-shrink: 0;\n  "])), getVariantColor(variant), getVariantColor(variant));
});
var Label = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var checkableField = _ref3.checkableField,
    children = _ref3.children,
    disabled = _ref3.disabled,
    disabledIcon = _ref3.disabledIcon,
    errorWarningIcon = _ref3.errorWarningIcon,
    variant = _ref3.variant,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    disabled: disabled,
    disabledIcon: disabledIcon,
    ref: ref,
    variant: variant
  }, rest), children);
});
Label.displayName = 'Label';

export { Disabled, Icon, Label, StyledLabel, requiredStyles };
